import Vue from "vue";
import Vuex from "vuex";


Vue.use(Vuex);

export default new Vuex.Store({
  /**
   * 各个模块的状态store管理
   */
  modules: {
  },
  state: {
    isLogin:false,//默认没有登录
    loginCode:sessionStorage.getItem('usercode') || '',
    loginPhone:sessionStorage.getItem('userphone') || '',
  },
  mutations: {
    login(state){
      state.isLogin = true;
    },
    logout(state){
      state.isLogin = false;
    },
    loginCode(state,data){
      sessionStorage.setItem('usercode', data);
      state.loginCode = data;
    },
    loginPhone(state,data){
      sessionStorage.setItem('userphone', data);
      state.loginPhone = data;
    },
  },
  actions: {
    updateLoginCode(context,data){
      context.commit('loginCode',data);
    },
    updateLoginPhone(context,data){
      context.commit('loginPhone',data);
    },
  },
});
